import { styled } from 'stitches.config'
import { CustomMealPlanRoot } from '../../../FivePound/components/CustomMealPlan/CustomMealPlan.styles'

export const FeedGreatRoot = styled(CustomMealPlanRoot, {
  marginBottom: '-40px',
})

export const ContentWrapper = styled('div', {
  position: 'absolute',
  right: '50px',
  top: 0,
  zIndex: 2,
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  textAlign: 'center',
  height: '100%',
  margin: '0 auto',
  maxWidth: '600px',
  paddingBottom: '200px',
  display: 'none',

  '@bp3': {
    display: 'flex',
  },

  '@bp4': {
    right: '100px',
    paddingBottom: '250px',
    maxWidth: '700px',
  },
})

export const Spacer = styled('div', {
  height: '30px',
})
